import { subdomains } from "@/common/consts";
import GrammarHome from "@/pages/Grammar/Home/GrammarHome.vue";
import GrammarDetail from "@/pages/Grammar/Detail/GrammarDetail.vue";
import ExperimentOverride from "@/pages/ExperimentOverride/ExperimentOverride.vue";

export default [
    {
        path: "/",
        name: "GrammarHome",
        meta: {
            subdomain: subdomains.GRAMMAR
        },
        component: GrammarHome
    },
    {
        path: "/abexp/:channel?",
        name: "ExperimentOverride",
        component: ExperimentOverride
    },
    {
        path: "/*",
        name: "GrammarDetail",
        meta: {
            subdomain: subdomains.GRAMMAR
        },
        component: GrammarDetail
    }
];



// WEBPACK FOOTER //
// ./src/router/routes/subdomain.grammar.js